import angular from 'angular';

(function() {
    'use strict';

    // Component DEF
    var kissInvoiceSection = {
        controller: 'InvoiceSectionCtrl as vm',
        templateUrl: require('./invoice-section.html'),
        bindings: {
            addFn: '&',
            removeItemFn: '&',
            editable: '<', // Binding dans un sens parent controller => controller du composant
            filters: '<',
            fullAttributes: '<',
            invoiceAttributes: '<',
            initClosed: '<',
            sectionAttributes: '<',
            typeSection: '@'
        }
    };

    // Add to the App
    angular.module('app.principal').component('kissInvoiceSection', kissInvoiceSection);
})();
